import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

const getSystemTheme = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";

export function ThemeProvider({ children }) {
  // Default to the OS preference on first visit; the explicit choice (if any)
  // stored by the user always wins afterwards.
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("crd_theme") || getSystemTheme();
    } catch {
      return getSystemTheme();
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    try {
      localStorage.setItem("crd_theme", theme);
    } catch {
      // Private mode etc. — the theme still applies for this session.
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
